<template>
  <v-card max-width="800">
    <label for="planillaId">Planilla ID: {{ planilla.id }}</label>
    {{ validForm }}

    <v-card-text>
      <v-form v-model="validForm" v-if="modo">
        <v-row class="ma-1">
          <v-col cols="6">
            <AsignacionAutocomplete
              ref="asig"
              :filtro="[1, 5, 6, 13, 15, 23]"
              :id="planilla.asignacion ? planilla.asignacion.id : null"
              @asignacionId="setAsignacionId"
            />
          </v-col>
          <v-col cols="6">
            <v-checkbox value="principal" label="Principal" />
          </v-col>
        </v-row>
        <v-row class="ma-1">
          <!-- <v-col cols="6">
            <v-autocomplete
              label="Rubro"
              v-model="planilla.rubro"
              :items="rubros"
              no-data-text="rubro no existe"
            ></v-autocomplete>
          </v-col> -->

          <v-col cols="6">
            <v-text-field
              :rules="[rules.required]"
              label="Local"
              type="text"
              class="form-control"
              id="local"
              placeholder="Deportivo aleman"
              v-model="planilla.local"
            />
          </v-col>
        </v-row>
        <v-row class="ma-1">
          <v-col cols="6">
            <v-text-field
              label="Interprete/Orquesta"
              type="text"
              class="form-control"
              id="interprete"
              placeholder="Talento de Barrio"
              v-model="planilla.interprete"
            />
          </v-col>

          <v-col cols="6">
            <v-text-field
              label="Nombre del evento"
              type="text"
              class="form-control"
              id="nombreEvento"
              placeholder="Nombre del evento"
              v-model="planilla.nombreEvento"
            />
          </v-col>
        </v-row>

        <v-row class="ma-1">
          <v-col cols="6">
            <v-text-field
              label="Fecha"
              type="text"
              :rules="[rules.required]"
              class="form-control"
              id="fecha"
              placeholder="DD/MM/AAAA"
              hint="DD/MM/AAAA"
              v-model.lazy="planilla.fecha"
            />
          </v-col>
          <!-- <Datepicker  input-class="form-control" :language="es" :typeable="true" :format="dateFormat" v-model="planilla.fecha"></Datepicker> -->

          <v-col cols="6">
            <v-text-field
              disabled
              label="Nro. Factura"
              type="text"
              class="form-control"
              id="numeroFactura"
              placeholder="000-000-0012345"
              v-model="planilla.numeroFactura"
            />
            <vue-numeric
              class="form-control"
              currency="Gs"
              separator="."
              v-model="planilla.montoFactura"
            ></vue-numeric>
            <AgregarFactura @facturaSeleccionada="facturaSeleccionada" />
          </v-col>
        </v-row>

        <v-row class="ma-1">
          <v-col cols="12">
            <v-text-field
              label="Observacion"
              type="text"
              class="form-control"
              id="observacion"
              placeholder="Observacion"
              v-model="planilla.observacion"
            />
          </v-col>
        </v-row>

        <!-- <input
            class="form-check-input"
            type="checkbox"
            name="tipo"
            id="principal"
            value="true"
            principal
            v-model="planilla.principal"
          />
          <label class="form-check-label" for="principal"> Principal </label> -->

        <div class="form-group col-md-6">
          <div v-if="planilla.detalle">
            Cantidad de temas: {{ planilla.detalle.length }}
          </div>
        </div>

        <hr />

        <v-card>
          <v-data-table :headers="headers" :items="planilla.detalle">
            <template v-slot:[`item.action`]="props">
              <v-btn v-if="props" @click="eliminarItem(props.item.id)">X</v-btn>
            </template>
          </v-data-table>
        </v-card>

        <!-- 
    <modal v-if="true" @close="showModal = false">
        <h3 slot="header">custom header</h3>
    </modal> 
    -->
        <!-- 
    <AgregarTema
      v-if="showModal"
      @nuevoNombreAutor="autorBuscado"
      @close="showModal = false"
      @seleccion="agregarTema"
      v-bind:nombreAutorAnterior="nombreAutor"
    ></AgregarTema> -->
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn
        type="submit"
        class="btn btn-outline-primary"
        @click.prevent="volver"
      >
        Volver
      </v-btn>
      <AgregarTema
        @nuevoNombreAutor="autorBuscado"
        @seleccion="agregarTema"
        v-bind:nombreAutorAnterior="nombreAutor"
      />
      <hr />
      <div v-if="showSuccessMessage" class="alert alert-success" role="alert">
        Guarado exitosamente!
      </div>
      <v-btn
        type="submit"
        class="btn btn-primary"
        @click.prevent="guardar"
        :disabled="
          saveDisabled || readOnly || !validForm || !$refs.asig.validForm
        "
      >
        Guardar
      </v-btn>
      <span class="red--text">{{ errorMessage }}</span>
    </v-card-actions>
  </v-card>
</template>


<script>
import axios from "axios";
// import Datepicker from 'vuejs-datepicker';
//import {es} from 'vuejs-datepicker/dist/locale';
import AgregarTema from "@/components/planilla/AgregarTema.vue";
import AgregarFactura from "@/components/planilla/AgregarFactura.vue";
import VueNumeric from "vue-numeric";
import moment from "moment";
import AsignacionAutocomplete from "@/components/shared/AsignacionAutocomplete";

export default {
  components: {
    // Datepicker,
    AgregarTema,
    AgregarFactura,
    VueNumeric,
    AsignacionAutocomplete,
  },

  created() {},

  mounted() {
    if (this.$route.params.id) {
      axios
        .get("/planillas/" + this.$route.params.id)
        .then((res) => {
          console.log(res);
          if (res.data) {
            this.planilla = res.data;
            this.planilla.fecha = moment(res.data.fecha).format("DD/MM/YYYY");
            this.modo = "edicion";
          }
          console.log("modo", this.modo);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = err.response.data;
        });
    } else {
      this.modo = "nuevo";
    }
  },

  data() {
    return {
      readOnly: false,
      showSuccessMessage: false,
      showModal: false,
      validForm: false,

      errorMessage: "",
      saveDisabled: false,
      modo: null,
      dateFormat: "dd/MM/yyyy",
      nombreAutor: "",

      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
        positive: (value) => value > 0 || "Ingrese un valor mayor a 0",
      },

      facturas: [],

      rubros: [
        "ejecucionPublica",
        "concierto",
        "actuacionTv",
        "usuarioFijo",
        "aparatoRadio",
        "streaming",
        "aparatoTv",
        "aparatoRadio",
        "tvAbiertoCable",
        "radio",
        "conciertos",
        "conciertosViaStreaming",
      ],
      //items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      rubroSelected: null,

      planilla: {
        local: "",
        interprete: "",
        direccion: "",
        director: "",
        localidad: "",
        director2: "",
        organizador: "",
        localidad2: "",
        fecha: "",
        telefono: "",
        nombreEvento: "",
        email: "",
        principal: false,
        rubro: "ejecucionPublica",
        numeroFactura: "",
        montoFactura: 0,
        asignacion: { id: null },
        detalle: [],
      },

      nombreTema: "",

      headers: [
        { text: "codigoSGS", value: "codWorkSq" },
        { text: "Nombre", value: "nombreTema" },
        { text: "Eliminar", value: "action" },
      ],
    };
  },

  watch: {
    "planilla.fecha": function (newVal) {
      if (newVal && !moment(newVal, "DD/MM/YYYY", true).isValid()) {
        this.planilla.fecha = "";
      }
    },
  },
  methods: {
    setAsignacionId(id) {
      if (this.planilla.asignacion == null) {
        this.planilla.asignacion = { id: id };
      } else {
        this.planilla.asignacion.id = id;
      }
    },
    autorBuscado(nombreAutor) {
      this.nombreAutor = nombreAutor;
    },
    mostrarBuscador() {
      this.showModal = true;
    },

    agregarTema(tema) {
      this.showModal = false;

      if (this.planilla.id > 0) {
        axios
          .post("/planillas/" + this.planilla.id + "/detalles", {
            codWorkSq: tema.id,
            nombreTema: tema.nombre,
            autores: tema.autores,
          })
          .then((res) => {
            console.log("res", res);
            this.planilla.detalle.push(res.data);
            this.showSuccessMessage = true;
            setTimeout(() => {
              this.showSuccessMessage = false;
            }, 3000);
          })
          .catch((err) => console.log(err));
      } else {
        //inventamos un id temporal
        this.planilla.detalle.push({
          id: Math.ceil(Math.random() * 1000),
          codWorkSq: tema.id,
          nombreTema: tema.nombre,
          autores: tema.autores,
        });
      }
    },
    guardar() {
      console.log("****", this.planilla);

      this.saveDisabled = true;

      this.planilla.fecha = moment(this.planilla.fecha, "DD/MM/YYYY");

      if (this.modo === "nuevo") {
        axios
          .post("/planillas", this.planilla)
          .then((res) => {
            //console.log(res)
            axios.get("/planillas/" + res.data.id).then((res) => {
              //console.log(res);
              this.planilla = res.data;
              this.planilla.fecha = moment(res.data.fecha).format("DD/MM/YYYY");
              this.modo = "edicion";
              this.saveDisabled = false;
              this.showSuccessMessage = true;
              setTimeout(() => {
                this.showSuccessMessage = false;
              }, 3000);
              this.$router.back();
            });
          })
          .catch((err) => {
            console.log(err);
            this.errorMessage = err.response.data;
          });
      }

      if (this.modo === "edicion") {
        axios
          .put("/planillas/" + this.planilla.id, this.planilla)
          .then((res) => {
            console.log("restPUT", res);
            axios
              .get("/planillas/" + this.planilla.id)
              .then((res) => {
                console.log(res);
                this.planilla = res.data;
                this.planilla.fecha = moment(res.data.fecha).format(
                  "DD/MM/YYYY"
                );
                this.saveDisabled = false;
                this.showSuccessMessage = true;
                setTimeout(() => {
                  this.showSuccessMessage = false;
                }, 3000);
                this.$router.back();
              })
              .catch((err) => console.log("errGet", err));
          })
          .catch((err) => {
            console.log("errPut", err);
            this.errorMessage = err.response.data;
          });
      }
    },

    eliminarItem(id) {
      console.log("********", id);

      if (this.planilla.id > 0) {
        axios
          .delete("/planillas/" + this.planilla.id + "/detalles/" + id)
          .then(() => {
            //this.planilla.detalle.splice(index, 1);
            this.planilla.detalle = this.planilla.detalle.filter(
              (pd) => pd.id != id
            );
            this.showSuccessMessage = true;
            setTimeout(() => {
              this.showSuccessMessage = false;
            }, 3000);
          })
          .catch((err) => console.log(err));
      } else {
        this.planilla.detalle = this.planilla.detalle.filter(
          (pd) => pd.id != id
        );
      }
    },
    rubro(rubro) {
      this.planilla.rubro = rubro;
    },
    isValidDate() {
      alert(moment("05/22/2012", "MM/DD/YYYY", true).isValid()); //true
    },
    volver() {
      this.$router.back();
    },
    facturaSeleccionada(factura) {
      if (factura) {
        this.planilla.numeroFactura = factura.codDocumento;
        this.planilla.montoFactura = factura.exentas;
      }
    },
  },
};
</script>
